import { ndefault } from '@models/util';
import z from 'zod';

export type Address = z.infer<typeof Address>;

export const Address = z.object({
  street: ndefault(z.string(), ''),
  city: ndefault(z.string(), ''),
  zip: ndefault(z.string(), ''),
  hash: z.string().nullish(),
  placeId: z.string().nullish(),
  lat: z.number().nullish(),
  lng: z.number().nullish(),
});
